import React, { useContext } from 'react';
import { UserContext } from '../../Context/User';
import { CartIcon, UserIcon } from '../../svg';
import styled from '@emotion/styled';
import { CartContext } from '../../Context/CartContext';
import { ContentfulContext } from '../../Context/Contentful';
import HeaderLogo from './HeaderLogo';

const StyledHeader = styled.div`
	box-shadow: 0px 3px 7px rgb(0 0 0 / 8%);
	padding: 22px 0;

	.header_vir {
		padding: 12px 0;
	}

	.header_adc {
		padding: 18px 0;
	}

	.header_newstf {
		padding: 18px 0;
	}
`;

function Header({ brandData }) {
	const { handleToggleCart } = useContext(CartContext);
	const { userData, logoutUser } = useContext(UserContext);
	const {
		allowExistingCustomer,
		products,
		entries: {
			items: [
				{
					fields: { partnerLogoLink },
				},
			],
		},
	} = useContext(ContentfulContext);
	const { logo, name, tag } = brandData;
	let isLoggedIn = userData && userData.securityStatus >= 4;

	const signInUser = () => {
		window.open(
			`/jsp/curity/signin.jsp?redirectionURL=${location.href}`,
			'_self'
		);
	};

	return (
		<StyledHeader
			className={'background-white position-relative header_' + tag}
		>
			<div className='container'>
				<div className='header__main__inner d-flex justify-content-between align-items-center'>
					<div className='header__main-center d-flex justify-content-start align-items-center flex-shrink-0'>
						<HeaderLogo brandData={brandData} />
					</div>
					<div className='header__main-right d-flex justify-content-end align-items-center js_header_cta flex-shrink-0'>
						{allowExistingCustomer && (
							<div
								className={`header__user text-center d-flex justify-content-center align-items-center flex-column position-relative cursor-pointer text-decoration-none ml-35`}
								title='Click to Sign in'
								onClick={() => {
									if (isLoggedIn) {
										logoutUser();
									} else {
										signInUser();
									}
								}}
							>
								<UserIcon />
								<span className='text_big d-none d-md-inline-block text-dark-medium pt-4'>
									{isLoggedIn ? 'Logout' : 'Sign in'}
								</span>
							</div>
						)}

						{products && products.length > 0 && (
							<div
								className='header__cart js_open_mini_cart_v2 text-center d-flex justify-content-center align-items-center flex-column cursor-pointer position-relative text-decoration-none ml-40'
								onClick={() => {
									handleToggleCart();
								}}
							>
								<span className='header__cart__quantity position-absolute font-weight-bold text-white text_xsmall js_header_quantity d-flex justify-content-center align-items-center'></span>
								<CartIcon />
								<span className='text_big d-none d-md-inline-block text-dark-medium pt-4'>
									Cart
								</span>
							</div>
						)}
					</div>
				</div>
			</div>
		</StyledHeader>
	);
}

export default Header;
